import { render, staticRenderFns } from "./crudStockControl.vue?vue&type=template&id=9dedfca4&scoped=true&"
import script from "./crudStockControl.vue?vue&type=script&lang=js&"
export * from "./crudStockControl.vue?vue&type=script&lang=js&"
import style0 from "./crudStockControl.vue?vue&type=style&index=0&id=9dedfca4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dedfca4",
  null
  
)

export default component.exports